import { Directive, Input } from '@angular/core';
import { Router } from '@angular/router';
import { isObjectEmpty } from 'src/app/_helpers/utils';
import { ProposalService } from 'src/app/_services/proposal.service';
import {
  BusinessRetirementMetadata,
  BusinessRetirementStaff,
} from 'src/app/_types/lead.types';
import { getBusinessLPPTypeLabel } from 'src/app/enums/business/business-lpp-type.enum';
import { getBusinessRetirementPlanLabel } from 'src/app/enums/business/business-retirement-plan.enum';
import { getCollaboratorLPPPlanLabel } from 'src/app/enums/business/collaborator-lpp-plan.enum';
import { getPaymentFrequencyLabel } from 'src/app/enums/payment-frequency.enum';
import { getSexEnumLabel } from 'src/app/enums/sex.enum';
import { getBooleanLabel } from 'src/app/helpers/utils';

import { BaseMetadataComponent } from '../../base-metadata.component';

@Directive()
export abstract class BusinessRetirementMetadataComponentAbstract extends BaseMetadataComponent<BusinessRetirementMetadata> {
  getBooleanLabel = getBooleanLabel;

  getBusinessRetirementPlanLabel = getBusinessRetirementPlanLabel;

  getBusinessLPPTypeLabel = getBusinessLPPTypeLabel;

  getCollaboratorLPPPlanLabel = getCollaboratorLPPPlanLabel;

  getPaymentFrequencyLabel = getPaymentFrequencyLabel;

  getSexEnumLabel = getSexEnumLabel;

  constructor(
    proposalService: ProposalService,
    private readonly router: Router
  ) {
    super(proposalService);
  }

  @Input()
  userId: string;

  viewCollaborator(collaboratorId: string): void {
    if (this.userId) {
      this.router.navigate([
        '/customers/view/collaborator',
        this.userId,
        collaboratorId,
      ]);
    }
  }

  getStaffSummary(staff?: BusinessRetirementStaff[]): string {
    if (!staff?.length) return '';
    return staff.map((s) => `${s.firstName} ${s.lastName}`).join(', ');
  }

  // Helper methods to check if objects are empty
  isContractInfoEmpty(metadata?: BusinessRetirementMetadata): boolean {
    if (!metadata) return true;
    return (
      !metadata.startDate &&
      !metadata.contractDuration &&
      !metadata.paymentFrequency &&
      (metadata.splitPaymentFee === null ||
        metadata.splitPaymentFee === undefined)
    );
  }

  isAdditionalInfoEmpty(metadata?: BusinessRetirementMetadata): boolean {
    if (!metadata) return true;
    return (
      !metadata.plan &&
      (metadata.collaboratorsCount === null ||
        metadata.collaboratorsCount === undefined) &&
      (metadata.coordinationDeduction === null ||
        metadata.coordinationDeduction === undefined) &&
      (metadata.insuredSalary === null ||
        metadata.insuredSalary === undefined) &&
      !metadata.retirementType &&
      (metadata.otherAmount === null || metadata.otherAmount === undefined) &&
      (metadata.partTimeIncluded === null ||
        metadata.partTimeIncluded === undefined) &&
      (metadata.minimalSalaryInsured === null ||
        metadata.minimalSalaryInsured === undefined) &&
      (metadata.otherInsuredSalary === null ||
        metadata.otherInsuredSalary === undefined)
    );
  }

  isContributionsEmpty(contributions: any): boolean {
    if (!contributions) return true;
    return (
      (contributions.eighteenToTwentyFour === null ||
        contributions.eighteenToTwentyFour === undefined) &&
      (contributions.twentyFiveToThirtyFour === null ||
        contributions.twentyFiveToThirtyFour === undefined) &&
      (contributions.thirtyFiveToFourtyFour === null ||
        contributions.thirtyFiveToFourtyFour === undefined) &&
      (contributions.fourtyFiveToFiftyFour === null ||
        contributions.fourtyFiveToFiftyFour === undefined) &&
      (contributions.fiftyFiveTosixtyFive === null ||
        contributions.fiftyFiveTosixtyFive === undefined)
    );
  }

  isObjectEmpty = isObjectEmpty;
}
